import React from "react";
import { Flex, Heading, useTheme } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";

export function SignInHeader() {
  const { tokens } = useTheme();
  const { t } = useTranslation();

  return (
    <Flex>
      <Heading
        level={3}
        padding={`${tokens.space.xl} ${tokens.space.xl} 0`}
        fontWeight={700}
        fontSize={"32px"}
        width="100%"
        textAlign="center"
      >
        {t("Sign in")}
      </Heading>
    </Flex>
  );
}
